<template>
    <div class="devices-list__block" v-if="deviceData">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData"></device-favorite>
                <device-switch-enable :device="deviceData"></device-switch-enable>
            </v-flex>
        </v-layout>
        <v-flex d-flex justify-end>
            <div v-if="deviceData.is_action && deviceData.state" class="note-row">
                {{deviceData.state.last_update.slice(0, 16)}}, &nbsp
            </div>
        </v-flex>
    </div>
</template>

<script>
export default {
    name: "SocketDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
}
</script>